import React, { useState, useEffect } from "react";
import "./App.css";
import { Call, Smartphone, MailOutline, Facebook } from "@mui/icons-material";

function App() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const testimonials = [
    {
      id: 1,
      feedback:
        "David and his team provide an excellent service. Always on time and our windows are spotless every time!",
      customer: "Sarah T",
    },
    {
      id: 2,
      feedback:
        "Been using SUDS for over 3 years now. Reliable, professional and great value for money.",
      customer: "Mike J",
    },
    {
      id: 3,
      feedback:
        "Outstanding service! They cleaned our conservatory beautifully. Highly recommended.",
      customer: "Emma W",
    },
    {
      id: 4,
      feedback:
        "Professional pressure washing service transformed our driveway. Couldn't be happier!",
      customer: "Robert D",
    },
    {
      id: 5,
      feedback:
        "David is trustworthy and does an amazing job. Our windows have never looked better.",
      customer: "Linda M",
    },
  ];

  // Auto-advance carousel every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  // Get exactly 5 testimonials to display
  const getVisibleTestimonials = () => {
    const visible = [];
    for (let i = 0; i < 5; i++) {
      const index =
        (currentIndex - 2 + i + testimonials.length) % testimonials.length;
      visible.push({
        ...testimonials[index],
        position: i, // 0 = far left, 1 = left, 2 = center, 3 = right, 4 = far right
      });
    }
    return visible;
  };

  return (
    <div className="app-container">
      <header className="app-header" role="banner">
        <div className="logo-section">
          <img
            src={require("./assets/suds.png")}
            alt="SUDS Window Cleaning Services - Professional Window Cleaners Middlesbrough"
            className="suds-logo-img"
          />
        </div>
      </header>

      <main className="flyer" role="main">
        {/* Hidden SEO heading */}
        <h1 className="seo-hidden">
          Professional Window Cleaning Services in Stockton-on-Tees & Teesside |
          SUDS
        </h1>

        {/* Bubbles */}
        <div className="bubble bubble-1 bubble-light"></div>
        <div className="bubble bubble-2 bubble-white"></div>
        <div className="bubble bubble-3 bubble-dark"></div>
        <div className="bubble bubble-4 bubble-light"></div>
        <div className="bubble bubble-5 bubble-dark"></div>
        <div className="bubble bubble-6 bubble-light"></div>
        <div className="bubble bubble-7 bubble-dark"></div>
        <div className="bubble bubble-8 bubble-white"></div>
        <div className="bubble bubble-9 bubble-light"></div>
        <div className="bubble bubble-10 bubble-dark"></div>

        {/* Additional Bubbles for Enhanced Effect */}
        <div className="bubble bubble-11 bubble-white"></div>
        <div className="bubble bubble-12 bubble-light"></div>
        <div className="bubble bubble-13 bubble-dark"></div>
        <div className="bubble bubble-14 bubble-white"></div>
        <div className="bubble bubble-15 bubble-light"></div>
        <div className="bubble bubble-16 bubble-dark"></div>
        <div className="bubble bubble-17 bubble-white"></div>
        <div className="bubble bubble-18 bubble-light"></div>
        <div className="bubble bubble-19 bubble-dark"></div>
        <div className="bubble bubble-20 bubble-white"></div>

        {/* Services Section */}
        <section
          className="services-section"
          aria-labelledby="services-heading"
        >
          <h2 id="services-heading" className="seo-hidden">
            Our Professional Cleaning Services in Teesside
          </h2>
          <div className="services-tiles-grid">
            <article className="service-tile">
              <img
                src={require("./assets/upvc_and_conservatory_cleaning_tile.png")}
                alt="UPVC and Conservatory Cleaning Service Stockton-on-Tees"
                className="tile-image"
              />
              <div className="tile-content">
                <h3 className="tile-header">UPVC & Conservatory Cleaning</h3>
                <div className="tile-underline"></div>
                <p className="tile-text">
                  Professional UPVC and conservatory cleaning in
                  Stockton-on-Tees and Teesside. We restore the shine to your
                  UPVC frames, doors and conservatories using gentle cleaning
                  methods that remove dirt and buildup without causing damage.
                </p>
              </div>
            </article>

            <article className="service-tile">
              <img
                src={require("./assets/frames_sills_and_doors_tile.png")}
                alt="Window Frames, Sills and Doors Cleaning Service"
                className="tile-image"
              />
              <div className="tile-content">
                <h3 className="tile-header">Frames, Sills & Doors</h3>
                <div className="tile-underline"></div>
                <p className="tile-text">
                  Complete window cleaning service including frames, sills and
                  doors. All cleaned as standard with every window cleaning
                  visit in Stockton-on-Tees and Teesside area.
                </p>
              </div>
            </article>

            <article className="service-tile">
              <img
                src={require("./assets/pure_water_fed_system_tile.png")}
                alt="Pure Water Fed System Window Cleaning Stockton-on-Tees"
                className="tile-image"
              />
              <div className="tile-content">
                <h3 className="tile-header">Pure Water Fed System (WFP)</h3>
                <div className="tile-underline"></div>
                <p className="tile-text">
                  We use a pure water fed system that leaves your windows
                  spotless and streak-free. It's safer, eco-friendly, and
                  ensures a longer-lasting clean for your Stockton-on-Tees home
                  or business.
                </p>
              </div>
            </article>

            <article className="service-tile">
              <img
                src={require("./assets/fully_insured_tile.png")}
                alt="Fully Insured Window Cleaning Company Stockton-on-Tees"
                className="tile-image"
              />
              <div className="tile-content">
                <h3 className="tile-header">Fully Insured</h3>
                <div className="tile-underline"></div>
                <p className="tile-text">
                  We are fully insured window cleaners, giving you complete
                  peace of mind and confidence that your Teesside property is
                  protected while we clean your windows.
                </p>
              </div>
            </article>

            <article className="service-tile">
              <img
                src={require("./assets/pressure_washing_system_tile.png")}
                alt="Pressure Washing Service Stockton-on-Tees Teesside"
                className="tile-image"
              />
              <div className="tile-content">
                <h3 className="tile-header">Pressure Washing Service</h3>
                <div className="tile-underline"></div>
                <p className="tile-text">
                  Professional pressure washing service for driveways, patios
                  and outdoor areas in Stockton-on-Tees and surrounding Teesside
                  areas. Contact us for further details.
                </p>
              </div>
            </article>

            <article className="service-tile">
              <img
                src={require("./assets/unifirmed_cleaners_tile.png")}
                alt="Uniformed Professional Window Cleaning Staff"
                className="tile-image"
              />
              <div className="tile-content">
                <h3 className="tile-header">Uniformed Staff</h3>
                <div className="tile-underline"></div>
                <p className="tile-text">
                  Our professional window cleaning team are uniformed, polite
                  and friendly, so you always know who is working at your
                  Stockton-on-Tees property.
                </p>
              </div>
            </article>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact" aria-labelledby="contact-heading">
          <h2 id="contact-heading" className="seo-hidden">
            Contact SUDS Window Cleaning Stockton-on-Tees
          </h2>
          <div className="contact-label">Call David on:</div>
          <div className="phone-numbers">
            <div className="phone-line">
              <Call className="phone-icon" />
              <a
                href="tel:01642649835"
                className="phone"
                title="Call SUDS Window Cleaning on 01642 649835"
              >
                01642 649835
              </a>
            </div>
            <div className="phone-line">
              <Smartphone className="phone-icon" />
              <a
                href="tel:07949995475"
                className="phone"
                title="Call SUDS Window Cleaning mobile 0794 9995475"
              >
                0794 9995475
              </a>
            </div>
          </div>
          <div className="email-line">
            <MailOutline className="email-icon" />
            <a
              href="mailto:sudscleaningservicesltd@hotmail.com"
              className="email"
              title="Email SUDS Window Cleaning Services"
            >
              sudscleaningservicesltd@hotmail.com
            </a>
          </div>
          <div className="social">
            <a
              href="https://www.facebook.com/profile.php?id=100054881659575"
              target="_blank"
              rel="noopener noreferrer"
              className="facebook-link"
              title="Follow SUDS Window Cleaning on Facebook"
            >
              <Facebook className="facebook-icon" />
              <span>Find us on Facebook</span>
            </a>
          </div>
        </section>

        {/* Testimonials Section */}
        <section
          className="testimonials-section"
          aria-labelledby="testimonials-heading"
        >
          <div className="testimonials-container">
            <h2 id="testimonials-heading" className="testimonials-title">
              What Our Teesside Customers Say!
            </h2>

            <div className="modern-carousel">
              <div className="testimonials-display">
                {getVisibleTestimonials().map((testimonial, index) => (
                  <div
                    key={`testimonial-${testimonial.id}-${currentIndex}-${index}`}
                    className={`testimonial-card ${
                      testimonial.position === 2 ? "center-active" : ""
                    }`}
                  >
                    <img
                      src={require(testimonial.position === 2
                        ? "./assets/white_quotes.png"
                        : "./assets/quotes.png")}
                      alt="Quote"
                      className="quote-icon"
                    />
                    <p className="testimonial-text">{testimonial.feedback}</p>
                    <div className="customer-name">
                      - {testimonial.customer}
                    </div>
                  </div>
                ))}
              </div>

              {/* Modern dot indicators */}
              <div className="carousel-dots">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    className={`dot ${index === currentIndex ? "active" : ""}`}
                    onClick={() => setCurrentIndex(index)}
                    aria-label={`Go to testimonial ${index + 1}`}
                    title={`View testimonial ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* White Background with Wave Image Above Footer */}
        <div className="wave-separator">
          <img
            src={require("./assets/white_wave.png")}
            alt="Decorative wave"
            className="wave-image"
          />
          <div className="white-background-block"></div>
        </div>

        {/* Footer */}
        <footer className="footer" role="contentinfo">
          <div className="footer-container">
            <div className="footer-section company-info">
              <h3>SUDS Window Cleaning Services Teesside</h3>
              <p>
                Professional window cleaning services in Stockton-on-Tees and
                across Teesside since 2007. We provide crystal clear results
                with exceptional customer service for residential and commercial
                properties throughout the area.
              </p>
              <div className="established">Established 2007</div>
            </div>

            <div className="footer-section contact-info">
              <h4>Contact Our Teesside Team</h4>
              <div className="contact-details">
                <div className="phone-number">
                  <Call className="footer-phone-icon" />
                  <a href="tel:01642649835">01642 649835</a>
                </div>
                <div className="phone-number">
                  <Smartphone className="footer-phone-icon" />
                  <a href="tel:07949995475">0794 9995475</a>
                </div>
              </div>
            </div>

            <div className="footer-section service-areas">
              <h4>Service Areas</h4>
              <div className="areas">
                <div>Stockton-on-Tees</div>
                <div>Billingham</div>
                <div>Thornaby</div>
                <div>Eaglescliffe & Yarm</div>
                <div>Middlesbrough</div>
                <div>Redcar & Cleveland</div>
                <div>Hartlepool</div>
                <div>Ingleby Barwick</div>
              </div>
            </div>

            <div className="footer-section social-media">
              <h4>Connect With Us</h4>
              <div className="social-links">
                <a
                  href="https://www.facebook.com/profile.php?id=100054881659575"
                  className="social-link facebook"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Facebook className="footer-facebook-icon" />
                  <span>Facebook</span>
                </a>
                <div className="social-handle">SudsCleaningServices</div>
              </div>
              <div className="follow-text">Follow us for tips and updates!</div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="copyright">
              © {new Date().getFullYear()} SUDS Window Cleaning Services Ltd.
              Professional window cleaners serving Stockton-on-Tees, Teesside &
              surrounding areas. All rights reserved.
            </div>
          </div>
        </footer>
      </main>
    </div>
  );
}

export default App;
